import React from "react";
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography
} from "@material-ui/core";
import { BookingSyncReportFragment } from "@graphql";
import locale from "@bonliva-crm/locale";
import { UserAvatarChip } from "@containers/UserAvatarChip";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  data: BookingSyncReportFragment;
};

export function BookingSyncReportTable(props: Props) {
  const { data } = props;

  const classes = useStyles({});

  const list = (
    <List>
      {data.Groups.map((group, i) => {
        const items = data.Items.filter(
          (x) => x.UserRef.PersonId === group.UserRef.PersonId
        );

        return (
          <>
            <ListItem>
              <ListItemText
                classes={{ primary: classes.total }}
                primary={<UserAvatarChip size="normal" userName={group.UserRef.Name} />}
              />
            </ListItem>

            {items.map((item) => {
              return (
                <ListItem key={item.ProjectName}>
                  <ListItemText primary={item.ProjectName} style={{ paddingLeft: 40 }} />
                  <ListItemSecondaryAction>
                    <Typography>{item.Score}</Typography>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}

            <ListItem>
              <ListItemText
                primary={locale.TotalGr}
                classes={{ primary: classes.total }}
                style={{
                  paddingLeft: 40
                }}
              />
              <ListItemSecondaryAction>
                <Typography className={classes.total}>{group.Total}</Typography>
              </ListItemSecondaryAction>
            </ListItem>
          </>
        );
      })}

      {data.Groups.length > 1 && <Divider />}

      {data.Groups.length > 1 && (
        <ListItem>
          <ListItemText primary={locale.TotalGr} classes={{ primary: classes.total }} />
          <ListItemSecondaryAction>
            <Typography className={classes.total}>{data.Total}</Typography>
          </ListItemSecondaryAction>
        </ListItem>
      )}
    </List>
  );

  return <div className={classes.root}>{list}</div>;
}

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: "40rem",
    marginLeft: "auto",
    marginRight: "auto"
  },

  total: {
    fontWeight: "bold"
  }
}));
